import { Model, ServerValidateQuestionsEvent } from "survey-core";
import {
  DEFAULT_PHONE_COUNTRY,
  type PhoneCountryCode,
  isPhoneCountryCode,
} from "../constants/phoneCountries";

export const validatePhoneNumber = async (
  survey: Model,
  options: ServerValidateQuestionsEvent,
) => {
  const rawPhoneNumber = options.data["telephone"];
  const trimmedPhone =
    typeof rawPhoneNumber === "string" ? rawPhoneNumber.trim() : "";
  if (!trimmedPhone) {
    options.complete();
    return;
  }

  if (!survey.api) {
    console.warn(
      "No API client available on survey object for phone number validation.",
    );
    options.complete();
    return;
  }

  const rawCountry = survey.getValue("telephone__country");
  const country: PhoneCountryCode = isPhoneCountryCode(rawCountry)
    ? rawCountry
    : DEFAULT_PHONE_COUNTRY;
  const encodedPhone = encodeURIComponent(trimmedPhone);

  await survey.api
    .get(`/driver/phone/number-lookup/${country}/${encodedPhone}`)
    .then(({ data }: { data: { phoneNumberInE164: string } }) => {
      survey.setValue("telephone", data.phoneNumberInE164);
    })
    .catch(() => {
      options.errors["telephone"] = "Vul een geldig telefoonnummer in";
    })
    .finally(() => options.complete());
};
